import { Button, IconExpand } from 'uikit';

import type { ICellRendererParams, IRowNode } from 'ag-grid-community';
import React, { useCallback } from 'react';

export interface IAgExpandCellRendererComponent<T> extends ICellRendererParams<T> {
    disabled?: boolean;
    onClick?: (data?: T) => void;
    isInvisible: (data?: T, node?: IRowNode<T>) => boolean;
}

export const AgExpandCellRendererComponent = <T extends {}>(props: IAgExpandCellRendererComponent<T>) => {
    const { disabled, onClick, data, isInvisible, node } = props;

    const onClickLocal = useCallback(() => {
        onClick?.(data);
    }, [data, onClick]);

    return isInvisible?.(data, node) ? (
        <div />
    ) : (
        <Button onClick={onClickLocal} disabled={disabled} iconLeft={IconExpand} onlyIcon view="clear" size="s" />
    );
};

AgExpandCellRendererComponent.displayName = 'AgExpandCellRendererComponent';
